const mathPatterns = [
  /[+-^/*%=]/,
  /\\[a-zA-Z]+(?:\{[^}]*})?/, // LaTeX commands: \frac{}, \alpha, etc.
];

const isMathContent = (text: string) => mathPatterns.some((pattern) => pattern.test(text));

export const preprocessMathMarkdown = (text: string) => {
  return (
    text
      // Escape all $ to avoid false positive katex recognition
      .replace(/\$/g, "\\$")
      // Convert display math: \[ ... \] to $$ ... $$
      .replace(/\\\[([\s\S]*?)\\]/g, (_, content) => (isMathContent(content) ? `$$${content}$$` : content))
      // Convert inline math: \( ... \) to $ ... $
      .replace(/\\\(([\s\S]*?)\\\)/g, (_, content) => (isMathContent(content) ? `$${content}$` : content))
  );
};
